// extracted by mini-css-extract-plugin
export default {"helpBlock":"RouterFAQBlock_helpBlock"};